module.exports = __webpack_public_path__ + "img/2.3fba66c6.jpg";